module.exports = __webpack_public_path__ + "img/75-l.89d83d92.png";